import { Pipe, PipeTransform } from '@angular/core';
@Pipe({  name: 'statusFilter', pure: false })
export class StatusFilterPipe implements PipeTransform {

  transform(records: Array<any>, args?: any): any {
    //console.log('args', args)
      if(records && records.length && args != 'All'){
        const statusId = args == true ? 1 : 2;
        return records.filter(obj => obj.statusId === statusId)
      } else{
          return records
      }
    }

 }
